import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import { Select } from '../../../../styles/styled';
import { getSoundcastsManagedv2 } from '../../../../helpers/userinfoHelper';
import Colors from '../../../../styles/colors';

const SoundcastSelector = props => {
  const [soundcastId, setSoundcastId] = useState(props.soundcastId);
  const [soundcast, setSoundcast] = useState({});
  // exclude bundles
  const soundcastsManaged = getSoundcastsManagedv2(({ bundle = false }) => !bundle);

  // set default soundcast
  useEffect(() => {
    if (isEmpty(soundcastId) && !isEmpty(soundcastsManaged)) {
      changeSoundcastId(soundcastsManaged[0].id);
    }
  }, [soundcastsManaged]);

  // call event when soundcast updates
  useEffect(() => {
    props.onSoundcastChange(soundcast, soundcastId);
  }, [soundcast]);

  const changeSoundcastId = soundcastId => {
    const soundcast = getSoundcastById(soundcastId);
    setSoundcastId(soundcastId);
    setSoundcast(soundcast);
  };

  const getSoundcastById = soundcastId => {
    if (!isEmpty(soundcastsManaged)) {
      const soundcast = soundcastsManaged.find(soundcast => isEqual(soundcast.id, soundcastId));
      if (soundcast) {
        return soundcast;
      }
    }

    return {};
  };

  return (
    <SoundcastSelect value={soundcastId} onChange={e => changeSoundcastId(e.target.value)}>
      {isEmpty(soundcastsManaged) && <option>Loading...</option>}
      {soundcastsManaged.map((soundcast, i) => {
        return (
          <option value={soundcast.id} key={i}>
            {soundcast.title}
          </option>
        );
      })}
    </SoundcastSelect>
  );
};

const SoundcastSelect = styled(Select)`
  background-color: ${Colors.mainWhite};
  margin: 0;
  font-size: 1.6rem;
  border-radius: 5px;
`;

SoundcastSelector.propTypes = {
  soundcastId: PropTypes.string,
  onSoundcastChange: PropTypes.func,
};

SoundcastSelector.defaultProps = {
  soundcastId: '',
  onSoundcastChange: () => {},
};

export default SoundcastSelector;
